import { CategoryType } from "enums";
import { CategoryModel } from "models";
import React from "react";
import { Utils } from "utils";

type PROPS = {
  category: CategoryModel[];
  options: {
    apply_item_large_category_id?: string;
    apply_item_medium_category_id?: string;
    apply_item_small_category_id?: string;
  };
  reRenderKey: number;
};

const ExhibitSearchItemCategoryInputs: React.FC<PROPS> = (props) => {
  const [larges, setLarges] = React.useState<CategoryModel[]>([]);
  const [midiums, setMidiums] = React.useState<CategoryModel[]>([]);
  const [smalls, setSmalls] = React.useState<CategoryModel[]>([]);

  const [valueL, setValueL] = React.useState("");
  const [valueM, setValueM] = React.useState("");
  const [valueS, setValueS] = React.useState("");

  React.useEffect(() => {
    setLarges(props.category);
  }, [props.category]);

  React.useEffect(() => {
    const valueL = props.options.apply_item_large_category_id;
    if (valueL === undefined) {
      setValueL("");
      setValueM("");
      setValueS("");
      setMidiums([]);
      setSmalls([]);
    } else {
      setValueL(valueL);

      const targetL = Utils.Category.pickCategory(valueL, props.category, CategoryType.LARGE);
      setMidiums(targetL?.list ?? []);
      const valueM = props.options.apply_item_medium_category_id;
      if (valueM === undefined) {
        setValueM("");
        setValueS("");
        setSmalls([]);
      } else {
        setValueM(valueM);

        const targetM = Utils.Category.pickCategory(valueL, targetL?.list ?? [], CategoryType.MIDDLE);
        setSmalls(targetM?.list ?? []);

        const valueS = props.options.apply_item_small_category_id;
        if (valueS === undefined) {
          setValueS("");
        } else {
          setValueS(valueS);
        }
      }
    }
  }, [props.category, props.options, props.reRenderKey]);

  return (
    <div className="flex justify-between items-center gap-4">
      <div>商品カテゴリ</div>
      <div className="flex-1 flex gap-2">
        <select
          className="flex-1"
          value={valueL}
          onChange={(e) => {
            const value = e.target.value;
            setValueL(value);
            if (value === "") {
              delete props.options.apply_item_large_category_id;
              delete props.options.apply_item_medium_category_id;
              delete props.options.apply_item_small_category_id;
              setValueM("");
              setValueS("");
              setMidiums([]);
              setSmalls([]);
            } else {
              props.options.apply_item_large_category_id = value;
              delete props.options.apply_item_medium_category_id;
              delete props.options.apply_item_small_category_id;
              setValueM("");
              setValueS("");
              const target = Utils.Category.pickCategory(value, props.category, CategoryType.LARGE);
              setMidiums(target?.list ?? []);
              setSmalls([]);
            }
          }}
        >
          <option value="">すべて</option>
          {larges.map((v, i) => {
            return (
              <option key={i} value={v.id}>
                {v.name}
              </option>
            );
          })}
        </select>
        <select
          className="flex-1"
          value={valueM}
          onChange={(e) => {
            const value = e.target.value;
            setValueM(value);
            if (value === "") {
              delete props.options.apply_item_medium_category_id;
              delete props.options.apply_item_small_category_id;
              setValueS("");
              setSmalls([]);
            } else {
              props.options.apply_item_medium_category_id = value;
              delete props.options.apply_item_small_category_id;
              setValueS("");
              const target = Utils.Category.pickCategory(value, props.category, CategoryType.MIDDLE);
              setSmalls(target?.list ?? []);
            }
          }}
          disabled={valueL === ""}
        >
          <option value="">すべて</option>
          {midiums.map((v, i) => {
            return (
              <option key={i} value={v.id}>
                {v.name}
              </option>
            );
          })}
        </select>
        <select
          className="flex-1"
          value={valueS}
          onChange={(e) => {
            const value = e.target.value;
            setValueS(value);
            if (value === "") {
              delete props.options.apply_item_small_category_id;
            } else {
              props.options.apply_item_small_category_id = value;
            }
          }}
          disabled={valueM === ""}
        >
          <option value="">すべて</option>
          {smalls.map((v, i) => {
            return (
              <option key={i} value={v.id}>
                {v.name}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default ExhibitSearchItemCategoryInputs;
